import {
  asFileList,
  buildLookupUploadFormData,
  extensionsToAccept,
  fileMatchesExtensions,
  getApiErrorMessage,
  isMultipleLookup,
  lookupIdFromLookup,
  matchMediaForLookup,
  pickUploadedFiles,
} from '@/utils/attachmentLookup'

export default {
  methods: {
    isFieldMultiple(field) {
      return isMultipleLookup(field?.lookup)
    },
    fieldAccept(field) {
      return extensionsToAccept(field?.lookup?.extensions) || undefined
    },
    getSelectedFilesForField(field) {
      return asFileList(this.fieldUploads?.[field?.key])
    },
    hasSelectedFiles(field) {
      return this.getSelectedFilesForField(field).length > 0
    },
    validateLookupFiles(field, files) {
      const list = asFileList(files)
      if (!list.length) {
        return 'اختر ملفًا للرفع'
      }

      if (!this.isFieldMultiple(field) && list.length > 1) {
        return 'هذا المرفق يقبل ملفًا واحدًا فقط'
      }

      const extensions = field?.lookup?.extensions
      const invalid = list.filter(file => !fileMatchesExtensions(file, extensions))
      if (invalid.length) {
        const accept = extensionsToAccept(extensions)
        const names = invalid.map(file => file.name).join(', ')
        return accept
          ? `نوع الملف غير مسموح (${names}). الأنواع المسموحة: ${accept}`
          : `نوع الملف غير مسموح (${names})`
      }

      return null
    },
    getConditionalFiles(key) {
      const field = (this.attachmentFields || []).find(item => item.key === key)
      const matched = field
        ? matchMediaForLookup(this.allFiles, field, this.normalizeName)
        : []

      const local = asFileList(this.localUploadedFiles?.[key]).map(item => ({
        ...item,
        name: item?.name || field?.label,
      }))

      const byId = new Map()
      const withoutId = []
      ;[...matched, ...local].forEach(item => {
        if (item?.id != null) {
          byId.set(item.id, item)
        } else if (item) {
          withoutId.push(item)
        }
      })

      const deletedIds = this.localDeletedFileIds || {}
      const merged = [...Array.from(byId.values()), ...withoutId]

      const files = merged.filter(item => {
        if (item?.id != null && deletedIds[item.id]) return false
        if (this.localDeletedFiles?.[key] && !this.isFieldMultiple(field)) return false
        return true
      })

      if (!this.isFieldMultiple(field)) {
        return files.slice(0, 1)
      }
      return files
    },
    getConditionalFile(key) {
      return this.getConditionalFiles(key)[0] || null
    },
    lookupUploadErrorMessage(error) {
      return getApiErrorMessage(error, 'تعذر حفظ الملف')
    },
    buildFieldUploadFormData(field, files) {
      return buildLookupUploadFormData({
        lookup: field?.lookup,
        files,
        name: field?.label,
      })
    },
    lookupIdOfField(field) {
      return lookupIdFromLookup(field?.lookup)
    },
    pickUploadedFilesFromResponse(responseData, fallbackLabel) {
      return pickUploadedFiles(responseData, fallbackLabel)
    },
  },
}
